import { useSelector } from 'react-redux';
import {
    Badge, CardFooter, Col, Row,
} from 'reactstrap';
import { Link } from '@s20/components/common/Link';
import { getCrewLeadLabel } from '@s20/selectors/features/common.selectors';
import { getMapUrl } from '@s20/common/util/dom';
import { AppNavPaths } from '../../../Common';

export const Job = ({ ...job }) => {
    const crewLead = useSelector(getCrewLeadLabel);

    return (
        <>
            <div className="p-2">
                <Row className="mb-2">
                    <Col>
                        <Link
                            to={
                                job.projectId
                                    ? `${AppNavPaths.Project}/${job.projectId}?openJob=${job.jobId}`
                                    : `${AppNavPaths.Job}/${job.jobId}`
                            }
                            target="_blank"
                            className="site-link h5 mb-0"
                        >
                            {job.jobNumber}
                        </Link>
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col xs="12">
                        <div className="text-muted text-uppercase small">
                            Customer
                        </div>

                        <div className="font-weight-semibold">
                            {job.customer || '-'}
                        </div>
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col xs="12">
                        <div className="text-muted text-uppercase small">
                            Location
                        </div>

                        <div className="font-weight-semibold text-break d-flex align-items-center">
                            <Badge
                                color="secondary"
                                className="mr-1"
                            >
                                J
                            </Badge>

                            <a
                                href={getMapUrl(job.jobLocationAddress)}
                                target="_blank"
                                className="site-link"
                                rel="noopener noreferrer"
                            >
                                {job.jobLocationAddress || '-'}
                            </a>
                        </div>

                        <div className="font-weight-semibold text-break d-flex align-items-center mt-1">
                            <Badge
                                color="secondary"
                                className="mr-1"
                            >
                                M
                            </Badge>

                            {job.meetingLocationAddress && job.meetingLocationAddress !== job.jobLocationAddress ? (
                                <a
                                    href={getMapUrl(job.jobLocationAddress)}
                                    target="_blank"
                                    className="site-link"
                                    rel="noopener noreferrer"
                                >
                                    {job.jobLocationAddress || '-'}
                                </a>
                            ) : 'Same as job location'}


                        </div>
                    </Col>
                </Row>

                {(job.crewLead || job.startTime) && (
                    <Row className="mb-2">
                        {job.crewLead && (
                            <Col xs={job.startTime ? '6' : '12'}>
                                <div className="text-muted text-uppercase small">
                                    {crewLead}
                                </div>

                                <div className="font-weight-semibold">
                                    {job.crewLead}
                                </div>
                            </Col>
                        )}

                        {job.startTime && (
                            <Col xs={job.crewLead ? '6' : '12'}>
                                <div className="text-muted text-uppercase small">
                                    Start Time
                                </div>
                                <div className="font-weight-semibold">
                                    {job.startTime}
                                </div>
                            </Col>
                        )}
                    </Row>
                )}

            </div>

            <CardFooter
                tag="footer"
                className="p-2 border-0"
            >
                <Row>
                    <Col
                        xs="6"
                        className="text-center"
                    >
                        <span>Required</span>

                        <div>
                            <Badge
                                color="secondary"
                                className="px-2"
                            >
                                {job.requiredResources || 0}
                            </Badge>
                        </div>
                    </Col>
                    <Col
                        xs="6"
                        className="text-center"
                    >
                        <span>Assigned</span>
                        <div>
                            <Badge
                                color={(job.assignmentCount || 0) >= (job.requiredResources || 0) ? 'success' : 'warning'}
                                className="px-2"
                            >
                                {job.assignmentCount || 0}
                            </Badge>
                        </div>
                    </Col>
                </Row>
            </CardFooter>
        </>
    );
};
